module.exports = "../img/weber-group-1iU6Y3b.svg";